import $ from 'jquery';
import slick from 'slick-carousel-browserify';

// GENERAL
//_________________________________________________________

// GET INVOLVED
//______________________________________________
if ($('.js--implementing-partners').length) {
	$('.js--implementing-partners').slick({
		slidesToShow: 6,
		slidesToScroll: 6,
		responsive: [
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 2
				}
			}
		]
	});
}
if ($('.js--supporting-partners').length) {
	$('.js--supporting-partners').slick({
		slidesToShow: 4,
		slidesToScroll: 4,
		arrows: true,
		prevArrow: `<button type="button" class="slick-prev"><img src="${themeData.templateDirectoryUri}/assets/images/slick_arrow_left.svg" alt="Arrow Left"></button>`,
		nextArrow: `<button type="button" class="slick-next"><img src="${themeData.templateDirectoryUri}/assets/images/slick_arrow_right.svg" alt="Arrow Right"></button>`,
		speed: 500,
		infinite: true,
		cssEase: 'ease-in',
		responsive: [
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1
				}
			}
		]
	});
}
if ($('.js--shop-slider').length) {
	$('.js--shop-slider').slick({
		slidesToShow: 5,
		slidesToScroll: 5,
		arrows: true,
		prevArrow: `<button type="button" class="slick-prev"><img src="${themeData.templateDirectoryUri}/assets/images/slick_arrow_left.svg" alt=""Arrow Left></button>`,
		nextArrow: `<button type="button" class="slick-next"><img src="${themeData.templateDirectoryUri}/assets/images/slick_arrow_right.svg" alt="Arrow Right"></button>`,
		speed: 500,
		infinite: true,
		cssEase: 'ease-in',
		responsive: [
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 4,
					slidesToScroll: 4,
				}
			},
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 2,
				}
			},
			{
				breakpoint: 400,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
				}
			}
		]
	});
}

// PROGRAMS
//______________________________________________
if ($('.js--programs-slider').length) {
	$('.js--programs-slider').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		dots: true,
		arrows: false,
		autoplay: true,
  		autoplaySpeed: 3000,
		speed: 500,
		infinite: true,
		cssEase: 'ease-out',
	});
}

// WHO WE ARE
//______________________________________________
if ($('.js--team-slider').length) {
	$('.js--team-slider').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: true,
		speed: 500,
		centerMode: false,
		infinite: true,
		mobileFirst: true,
		cssEase: 'ease-in',
		prevArrow: `<button type="button" class="slick-prev"><img src="${themeData.templateDirectoryUri}/assets/images/slick_arrow_left_simple.svg" alt="Arrow Left"></button>`,
		nextArrow: `<button type="button" class="slick-next"><img src="${themeData.templateDirectoryUri}/assets/images/slick_arrow_right_simple.svg" alt="Arrow Right"></button>`,
		responsive: [
			{
				breakpoint: 767,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 3,
				}
			},
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 4,
					slidesToScroll: 4,
				}
			}
		]
	});
}

// FRONT PAGE
//______________________________________________
if ($('.js--blog-slider').length) {
	$('.js--blog-slider').slick({
		slidesToShow: 5,
		slidesToScroll: 1,
		arrows: true,
		prevArrow: `<button type="button" class="slick-prev"><img src="${themeData.templateDirectoryUri}/assets/images/slick_arrow_left.svg" alt=""Arrow Left></button>`,
		nextArrow: `<button type="button" class="slick-next"><img src="${themeData.templateDirectoryUri}/assets/images/slick_arrow_right.svg" alt="Arrow Right"></button>`,
		speed: 500,
		infinite: true,
		cssEase: 'ease-in',
		responsive: [
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 3,
				}
			},
			{
				breakpoint: 600,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
					centerMode: false,
				}
			}
		]
	});
}

